{
  "apis": {
    "form": {
      "passport": {
        "scanUploadTitle": "Scan or upload your passport"
      }
    }
  },
  "checkIn": {
    "steps": {
      "apis": {
        "infoBox": {
          "ensureDetailsComplete": "Make sure that all details are complete and correct",
          "documentsPreChecked": "Travel documents verified",
          "documentsNotChecked": "",
          "seeAgentOrPreCheck": "Your document will be checked at the airport.",
          "seeAgentOrPreCheckButton": "Verify online and save time"
        }
      }
    }
  }
}
